import { render } from "./CompanyUserEdit.vue?vue&type=template&id=dcecacae&scoped=true"
import script from "./CompanyUserEdit.vue?vue&type=script&lang=js"
export * from "./CompanyUserEdit.vue?vue&type=script&lang=js"

import "./CompanyUserEdit.vue?vue&type=style&index=0&id=dcecacae&lang=scss&scoped=true"
import "./CompanyUserEdit.vue?vue&type=style&index=1&id=dcecacae&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcecacae"]])

export default __exports__